export const SERVICE_URL = "https://v1api.yfosclean.com";
// export const SERVICE_URL = "http://localhost:3001";
export const ALLOWED_IMAGE_SIZE_IN_BYTES = 12000000;
